<template>
  <v-dialog v-model="show" width="800" transition="dialog-bottom-transition" class="dialog">
      <template v-slot:default>
        <v-card>
          <div class="ma-4">
            <v-list>
              <v-list-item class="optionsBtns">
                <v-btn size="x-large" color="primary" variant="text" @click="updateOptions()">
                  <v-icon>mdi-check-bold</v-icon>
                </v-btn>
                <v-btn size="x-large" color="secondary" variant="text" @click="closeDialog()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item>
              <v-list-item title="Pompts">
                <v-expansion-panels>
                  <v-expansion-panel title="Agent Role" @click="trackPanelExpansion('prompt_agent_role')">
                    <template v-slot:text>
                      <div class="text-subtitle-2">
                        Create agent prompts based on agent name and description. You can use &lt;name&gt; and
                        &lt;description&gt; to dynamically fill in the agent's name and description.
                      </div>
                      <v-textarea label="Agent role prompt" v-model="agentPrompt" class="mt-2" />
                    </template>
                  </v-expansion-panel>
                  <v-expansion-panel title="Squad Workflow" @click="trackPanelExpansion('prompt_squad_workflow')">
                    <template v-slot:text>
                      <div class="text-subtitle-2">
                        Create the squad workflow message from all of the agent names and descriptions. You can use
                        &lt;name&gt;, &lt;description&gt; and &lt;squadData&gt; to dynamically fill in the squad
                        name and
                        description as well as all of the names and descriptions for the agents.
                      </div>
                      <v-textarea label="Squad workflow prompt" v-model="squadPromptInternal" class="mt-2" />
                    </template>
                  </v-expansion-panel>
                  <v-expansion-panel title="First Agent" @click="trackPanelExpansion('prompt_first_agent')">
                    <template v-slot:text>
                      <div class="text-subtitle-2">
                        Prompt for the leader model to determine the first agent. This needs to return only the
                        agent name, or
                        it will pick the first instance of an agent's name in the response. You can use
                        &lt;names&gt; to
                        dynamically fill in the list of agent names, and &lt;workflow&gt; to dynamically fill in the
                        squad's
                        workflow.
                      </div>
                      <v-textarea label="First agent prompt" v-model="firstAgentPromptInternal" class="mt-2" />
                    </template>
                  </v-expansion-panel>
                  <v-expansion-panel title="Leader" @click="trackPanelExpansion('prompt_leader')">
                    <template v-slot:text>
                      <div class="text-subtitle-2">
                        Prompt for the leader agent to determine the agent to route the reponse to. You can use
                        &lt;workflow&gt; to fill in the squad's workflow, &lt;names&gt; to fill in the list of agent
                        names in
                        the squad,
                        as well as &lt;agentName&gt; and &lt;agentResponse&gt; to dynamically fill in the responding
                        agent's
                        name and
                        response.
                      </div>
                      <v-textarea label="Leader prompt" v-model="leaderPromptInternal" class="mt-2" />
                    </template>
                  </v-expansion-panel>
                  <v-expansion-panel title="Open RAG Template" @click="trackPanelExpansion('prompt_open_rag')">
                    <template v-slot:text>
                      <v-textarea label="Open RAG Template" v-model="openRAGTemplateInternal" class="mt-2" />
                    </template>
                  </v-expansion-panel>
                  <v-expansion-panel title="Closed RAG Template" @click="trackPanelExpansion('prompt_closed_rag')">
                    <template v-slot:text>
                      <v-textarea label="Closed RAG Template" v-model="closedRAGTemplateInternal" class="mt-2" />
                    </template>
                  </v-expansion-panel>
                  <v-expansion-panel title="Code RAG Template" @click="trackPanelExpansion('prompt_code_rag')">
                    <template v-slot:text>
                      <v-textarea label="Code RAG Template" v-model="codeRAGTemplateInternal" class="mt-2" />
                    </template>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-list-item>
              <v-list-item title="Data">
                <v-expansion-panels>
                  <v-expansion-panel title="Import / Export" @click="trackPanelExpansion('data_import_export')">
                    <template v-slot:text>
                      <!-- <div class="text-subtitle-2">Export app configuration to a json file</div> -->
                      <v-btn variant="outlined" class="downloadConfig mt-4 mr-4" @click="downloadConfig()">
                        export config
                      </v-btn>
                    </template>
                  </v-expansion-panel>
                  <!-- <v-expansion-panel title="Clear Sections">
                    <template v-slot:text>
                      <v-btn variant="outlined" class="mt-4 mr-4" @click="clearModels()"> clear models </v-btn>
                      <v-btn variant="outlined" class="mt-4 mr-4" @click="clearAgents()"> clear agents </v-btn>
                      <v-btn variant="outlined" class="mt-4 mr-4" @click="clearSquads()"> clear squads </v-btn>
                      <v-btn variant="outlined" class="mt-4 mr-4" @click="clearMissions()"> clear missions </v-btn>
                      <v-btn variant="outlined" class="mt-4 mr-4" @click="clearPromptStudio()"> clear prompt studio
                      </v-btn>
                    </template>
                  </v-expansion-panel> -->
                </v-expansion-panels>
              </v-list-item>
              <v-list-item title="Utility Agents">
                <v-expansion-panels>
                  <v-expansion-panel title="Summary Agent (for chat titles)" @click="trackPanelExpansion('summary_agent')">
                    <template v-slot:text>
                      <div class="d-flex align-start">
                        <v-select 
                          v-model="selectedTitleAgent"
                          label="Summary Agent" 
                          :items="summaryAgentItems"
                          item-title="title"
                          item-value="value"
                          clearable
                          hide-details 
                          class="d-inline-block text-area-width" 
                        />
                      </div>
                    </template>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-list-item>
              <!-- <v-list-item>
                <div class="text-subtitle-2">
                  Share anonymized data for the purpose of bug fixing and improved user experience.
                </div>
                <v-checkbox label="Anonymous telemetry" v-model="telemetryInternal" @change="onTelemetryChange($event.target.checked)" />
              </v-list-item> -->

            </v-list>
          </div>
        </v-card>
      </template>
    </v-dialog>
</template>
<script lang="ts">
import { AgentDefaults } from '@/store/agents'
import { createHash, sleep } from '@/utils/general'
import { Options, mixins } from 'vue-class-component'
import { mapGetters } from 'vuex'
import AnalyticsMixin from '@/mixins/AnalyticsMixin'
import { SharedAgentInfo } from '@/types/agents'
import { encodeSharedTitleAgent } from '@/utils/summaryAgent'

@Options({
  computed: {
    ...mapGetters(['showOptions', 'agentDefaults', 'agentNames', 'titleAgent', 'sharedAgents']),
    // squadPrompt(): string {
    //   return this.$store.state.squads.config.prompt.content
    // },
    // firstAgentPrompt(): string {
    //   return this.$store.state.missions.config.prompt.first.content
    // },
    // leaderPrompt(): string {
    //   return this.$store.state.missions.config.prompt.leader.content
    // },
    // telemetry(): boolean {
    //   return this.$store.state.global.telemetry
    // },
    // openRAGTemplate(): string {
    //   return this.$store.state.embeddings.config.templates.open
    // },
    // closedRAGTemplate(): string {
    //   return this.$store.state.embeddings.config.templates.closed
    // },
    // codeRAGTemplate(): string {
    //   return this.$store.state.embeddings.config.templates.code
    // }
  }
})
export default class OptionsDialog extends mixins(AnalyticsMixin) {
  showOptions!: boolean
  agentDefaults!: AgentDefaults
  squadPrompt!: string
  squadPromptInternal: string = ''
  squadPromptHash: string = ''
  firstAgentPrompt!: string
  firstAgentPromptInternal: string = ''
  firstAgentPromptHash: string = ''
  leaderPrompt!: string
  leaderPromptInternal: string = ''
  leaderPromptHash: string = ''
  telemetry!: boolean
  telemetryInternal: boolean = false
  openRAGTemplate!: string
  openRAGTemplateInternal: string = ''
  openRAGTemplateHash: string = ''
  closedRAGTemplate!: string
  closedRAGTemplateInternal: string = ''
  closedRAGTemplateHash: string = ''
  codeRAGTemplate!: string
  codeRAGTemplateInternal: string = ''
  codeRAGTemplateHash: string = ''
  agentNames!: string[]
  sharedAgents!: SharedAgentInfo[]
  titleAgent!: string | null
  selectedTitleAgent: string | null = null

  get show() {
    return this.showOptions
  }

  set show(value: boolean) {
    if (value) {
      this.trackComponentView('options_dialog');
    }
    this.$store.dispatch('toggleOptions', value)
  }

  closeDialog() {
    this.trackButtonClick('close_options', 'click');
    this.show = false;
  }

  // --- PANEL EXPANSION ---
  trackPanelExpansion(panelTitle: string) {
    this.trackButtonClick('expand_options_panel', 'click', { panel_name: panelTitle });
  }

  async mounted() {
    // await this.$store.dispatch('initTracking')
    console.log('config loaded. app ready.')
    await sleep(500)
    if (this.telemetry) {
      this.telemetryInternal = true
    }

    this.selectedTitleAgent = this.titleAgent

    this.squadPromptInternal = this.squadPrompt
    this.squadPromptHash = await createHash(this.squadPromptInternal)
    this.firstAgentPromptInternal = this.firstAgentPrompt
    this.firstAgentPromptHash = await createHash(this.firstAgentPromptInternal)
    this.leaderPromptInternal = this.leaderPrompt
    this.leaderPromptHash = await createHash(this.leaderPromptInternal)
    this.openRAGTemplateInternal = this.openRAGTemplate
    this.openRAGTemplateHash = await createHash(this.openRAGTemplateInternal)
    this.closedRAGTemplateInternal = this.closedRAGTemplate
    this.closedRAGTemplateHash = await createHash(this.closedRAGTemplateInternal)
    this.codeRAGTemplateInternal = this.codeRAGTemplate
    this.codeRAGTemplateHash = await createHash(this.codeRAGTemplateInternal)
  }

  get agentPrompt() {
    if (this.agentDefaults != null && typeof this.agentDefaults.prompt.content === 'string') {
      return this.agentDefaults.prompt.content
    } else {
      return ''
    }
  }

  set agentPrompt(value: string) {
    this.trackFeatureUsage('options', 'update_prompt_template', { prompt_name: 'agent_role' });
    this.$store.dispatch('updateGeneratePrompt', { prompt: value })
  }

  get summaryAgentItems(): Array<{ title: string; value: string }> {
    const own = (this.agentNames || []).map((name) => ({ title: name, value: name }))
    const shared = (this.sharedAgents || []).map((agent) => ({
      title: `${agent.agentName} (shared by @${agent.ownerUsername})`,
      value: encodeSharedTitleAgent(agent)
    }))
    return [...own, ...shared]
  }

  async updateOptions() {
    this.trackButtonClick('save_options', 'click');
    
    const squadPromptHash = await createHash(this.squadPromptInternal);
    if (this.squadPromptHash !== squadPromptHash) {
      this.trackFeatureUsage('options', 'update_prompt_template', { prompt_name: 'squad_workflow' });
    }
    const firstAgentPromptHash = await createHash(this.firstAgentPromptInternal);
    if (this.firstAgentPromptHash !== firstAgentPromptHash) {
      this.trackFeatureUsage('options', 'update_prompt_template', { prompt_name: 'first_agent' });
    }
    const leaderPromptHash = await createHash(this.leaderPromptInternal);
    if (this.leaderPromptHash !== leaderPromptHash) {
      this.trackFeatureUsage('options', 'update_prompt_template', { prompt_name: 'leader' });
    }
    const openRAGTemplateHash = await createHash(this.openRAGTemplateInternal);
    if (this.openRAGTemplateHash !== openRAGTemplateHash) {
      this.trackFeatureUsage('options', 'update_prompt_template', { prompt_name: 'open_rag' });
    }
    const closedRAGTemplateHash = await createHash(this.closedRAGTemplateInternal);
    if (this.closedRAGTemplateHash !== closedRAGTemplateHash) {
      this.trackFeatureUsage('options', 'update_prompt_template', { prompt_name: 'closed_rag' });
    }
    const codeRAGTemplateHash = await createHash(this.codeRAGTemplateInternal);
    if (this.codeRAGTemplateHash !== codeRAGTemplateHash) {
      this.trackFeatureUsage('options', 'update_prompt_template', { prompt_name: 'code_rag' });
    }

    this.$store.dispatch('saveTitleAgent', this.selectedTitleAgent)
    // this.$store.dispatch('updateSquadPrompt', this.squadPromptInternal)
    // this.$store.dispatch('updateFirstAgentPrompt', this.firstAgentPromptInternal)
    // this.$store.dispatch('updateLeaderPrompt', this.leaderPromptInternal)
    // this.$store.dispatch('updateRAGTemplates', {
    //   open: this.openRAGTemplateInternal,
    //   closed: this.closedRAGTemplateInternal,
    //   code: this.codeRAGTemplateInternal
    // })
    // this.$store.dispatch('setTelemetry', this.telemetryInternal)
    // const data: { [key: string]: string } = {}
    // let updated: boolean = false

    // const squadPromptHash = await createHash(this.squadPromptInternal)
    // if (this.squadPromptHash !== squadPromptHash) {
    //   this.squadPromptHash = squadPromptHash
    //   data['squadPrompt'] = this.squadPromptInternal
    //   updated = true
    // }
    // const firstAgentPromptHash = await createHash(this.firstAgentPromptInternal)
    // if (this.firstAgentPromptHash !== firstAgentPromptHash) {
    //   this.firstAgentPromptHash = firstAgentPromptHash
    //   data['firstAgentPrompt'] = this.firstAgentPromptInternal
    //   updated = true
    // }
    // const leaderPromptHash = await createHash(this.leaderPromptInternal)
    // if (this.leaderPromptHash !== leaderPromptHash) {
    //   this.leaderPromptHash = leaderPromptHash
    //   data['leaderPrompt'] = this.leaderPromptInternal
    //   updated = true
    // }
    // const openRAGTemplateHash = await createHash(this.openRAGTemplateInternal)
    // if (this.openRAGTemplateHash !== openRAGTemplateHash) {
    //   this.openRAGTemplateHash = openRAGTemplateHash
    //   data['openRAGTemplate'] = this.openRAGTemplateInternal
    //   updated = true
    // }
    // const closedRAGTemplateHash = await createHash(this.closedRAGTemplateInternal)
    // if (this.closedRAGTemplateHash !== closedRAGTemplateHash) {
    //   this.closedRAGTemplate = closedRAGTemplateHash
    //   data['closedRAGTemplate'] = this.closedRAGTemplateInternal
    //   updated = true
    // }
    // const codeRAGTemplateHash = await createHash(this.codeRAGTemplateInternal)
    // if (this.codeRAGTemplateHash !== codeRAGTemplateHash) {
    //   this.codeRAGTemplateHash = codeRAGTemplateHash
    //   data['codeRAGTemplate'] = this.codeRAGTemplateInternal
    //   updated = true
    // }
    // if (updated) {
    //   this.$store.dispatch('sendTelemetry', { type: 'options', data })
    // }
    this.show = false;
  }

  downloadConfig() {
    this.trackButtonClick('export_config', 'click');
    // const { models, agents, squads, missions } = this.$store.state as AppState
    // const { modelConfigs } = models
    // const { agentConfigs } = agents
    // const { squadConfigs } = squads
    // const { missionConfigs } = missions
    // Object.keys(modelConfigs).forEach((key) => {
    //   const { apiKey } = modelConfigs[key]
    //   if (apiKey != null && apiKey !== '') {
    //     delete modelConfigs[key].apiKey
    //   }
    // })
    // const config = {
    //   models: modelConfigs,
    //   agents: agentConfigs,
    //   squads: squadConfigs,
    //   missions: missionConfigs
    // }
    // const date = new Date().toLocaleString().replace(' ', '-')
    // userDownloadJSON(`mission-squad-config_${date}.json`, config)
  }

  // --- TELEMETRY ---
  onTelemetryChange(enabled: boolean) {
    this.trackFeatureUsage('options', 'toggle_telemetry', { enabled });
  }

  // clearModels() {
  //   this.$store.dispatch('deleteAllModels')
  //   this.$store.dispatch('updateSnackbar', { text: `Models cleared`, timeout: 2_000 })
  // }

  // clearAgents() {
  //   this.$store.dispatch('deleteAllAgents')
  //   this.$store.dispatch('updateSnackbar', { text: `Agents cleared`, timeout: 2_000 })
  // }

  // clearSquads() {
  //   this.$store.dispatch('deleteAllSquads')
  //   this.$store.dispatch('updateSnackbar', { text: `Squads cleared`, timeout: 2_000 })
  // }

  // clearMissions() {
  //   this.$store.dispatch('deleteAllMissions')
  //   this.$store.dispatch('updateSnackbar', { text: `Missions cleared`, timeout: 2_000 })
  // }

  // clearPromptStudio() {
  //   this.$store.dispatch('deleteAllPrompts')
  //   this.$store.dispatch('updateSnackbar', { text: `Prompt Studio cleared`, timeout: 2_000 })
  // }
}
</script>
<style scoped lang="scss">
.dialog {
  z-index: 2000;
}
.optionsBtns {
  text-align: right;
}
.text-area-width {
  width: 80%;
}
</style>
